import React, { Component } from 'react';
import Header from "../component/header/Header";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Footer from "../component/footer/FooterTwo";
import { LanguageContext } from '../context/LanguageContext';
import translations from '../translations';

 class error404 extends Component {
    static contextType = LanguageContext;

    render() {
        const { language } = this.context;
        const t = translations[language];

        return (
            <>
                <Header headerPosition="header--transparent" color="color-white" logo="logo-light" />
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">{t.error404.title}</h1>
                                    <h3 className="sub-title">{t.error404.subtitle}</h3>
                                    <span>{t.error404.description}</span>
                                    <div className="error-button">
                                        <a className="rn-button-style--2 btn-solid" href="/">{t.error404.button}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </>
        )
    }
}
export default error404;
